module.exports = __webpack_public_path__ + "img/leadingsolutions.7ed1da4a.png";